import React, { Component } from 'react';
import { HashRouter, Route, Switch,  Link} from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom'
import Dashboard from './Dashboard';
import Academics from './Academics';
import Finance from './Finance';





class ContentArea extends Component {

   constructor(props) {
    super(props);


     this.state={
      user_details:this.props.user_details,
      access_token:this.props.access_token,
      app_data:this.props.app_data


     }
  }
  render() {
    const _this=this;

    console.log("app data", _this.props.app_data);

    return (
        <div>

            <Switch>
              <Route
                    exact path="/student_ui"
                    render={(props) => <Dashboard {...props}
                                                              student_details = {_this.props.student_details}
                                                              base_url={_this.props.base_url}
                                                              loginStatus= {this.props.loginStatus}
                                                              updateStudentDetails={_this.props.updateStudentDetails}/> }
              />
              <Route
                    path="/student_ui/dashboard"
                    render={(props) => <Dashboard {...props}
                                                            student_details = {_this.props.student_details}
                                                            base_url={_this.props.base_url}
                                                            loginStatus= {this.props.loginStatus}
                                                            updateStudentDetails={_this.props.updateStudentDetails}/> }
              />

            <Route
                    path="/student_ui/academics"
                    render={(props) => <Academics {...props} student_details = {_this.props.student_details}
                                                              base_url={_this.props.base_url}
                                                              loginStatus= {this.props.loginStatus}
                                                              updateStudentDetails={_this.props.updateStudentDetails}/> }
              />
              <Route
                    path="/student_ui/finance"
                    render={(props) => <Finance {...props} student_details = {_this.props.student_details}
                                                              base_url={_this.props.base_url}
                                                              loginStatus= {this.props.loginStatus}
                                                              renderInThousands = {this.props.renderInThousands}
                                                              updateStudentDetails={_this.props.updateStudentDetails}/> }
              />
              <Route
                    path="/student_ui/admission_details"
                    render={(props) => <Dashboard {...props} student_details = {_this.props.student_details}
                                                              base_url={_this.props.base_url}
                                                              renderInThousands = {this.props.renderInThousands}
                                                              loginStatus= {this.props.loginStatus}
                                                              updateStudentDetails={_this.props.updateStudentDetails}/> }
              />

            <Route
                    path="/student_ui/profile"
                    render={(props) => <Dashboard {...props} student_details = {_this.props.student_details}
                                                              base_url={_this.props.base_url}
                                                              loginStatus= {this.props.loginStatus}
                                                              updateStudentDetails={_this.props.updateStudentDetails}/> }
              />


            </Switch>
            </div>




    );
  }




}

export default ContentArea;
